import { Card, Label, TextInput } from 'flowbite-react'
import React, { useState } from 'react'
import { FaArrowRight, FaEye, FaEyeSlash } from 'react-icons/fa'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import * as styles from './ResetPassword.styles'
import Form from '../../components/Form/Form'
import CustomInput from '../../components/CustomInputs/CustomInput'
import CustomButton from '../../components/CustomButton/CustomButton'
import PublicLayout from '../../layouts/PublicLayout'
import showToast from '../../components/CustomToast/toastHelper'
import client from '../../api/client'

interface inputProps{
    code:string,
    password:string,
    cpassword:string
}
interface resetPassWordPayloadProps{
    identifier:string,
    otp:string,
    newPassword:string
}
const ResetPassword = () => {
    const [formValues, setFormValues]=useState<inputProps>({
        code:'',
        password:'',
        cpassword:''
    })
    const [loading, setLoading]= useState<any>(false)
    const [showPassword, setShowPassword] = useState<any>({
        password: false,
        cpassword: false,
    });

    const {state} = useLocation()
    
    const {email} = state
    const navigate = useNavigate()
    const handleChange =(e:React.ChangeEvent<HTMLInputElement>) =>{
        const { name, value } = e.target;
        setFormValues((prevValues:any) => ({
            ...prevValues,
            [name]: value
        }));
    }
    
    const payload:resetPassWordPayloadProps={
        identifier:email,
        otp:formValues.code,
        newPassword:formValues.password
    }
    const handleResetPassword = async(e:any) =>{
        e.preventDefault()
        setLoading(true)
        try{
            if(formValues.password !== formValues.cpassword){
                showToast("Passwords must match","error")
                setLoading(false)
                return
            }
            const resetPasswordResponse = await client.post("/subsidiary/dashboard/complete/forgot-password",payload)
            
            if(resetPasswordResponse.data.status =="success"){
                showToast(resetPasswordResponse.data.message,"success")
                navigate('/login')
                setLoading(false)
            }
            else{
                setLoading(false)
                showToast(resetPasswordResponse.data.message,"error")
            }
        }
        catch(err:any){
            console.error('Sign in error', err)
            setLoading(false)
            showToast(err.response.data.message,"error")
        }
    }

    const togglePasswordVisibility = (field: 'password' | 'cpassword') => {
        setShowPassword((prevState:any) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };
    return (
        <PublicLayout>
            <div className={styles.container}>
                <div className={styles.cardContainer}>
                <Card className={styles.card}>
                    <Form title="Reset Password" subtitle="Kindly enter your new password and confirm it to complete new password set up">
                        <CustomInput label='Enter Code' name='code' value={formValues.code} onChange={handleChange}/>
                        <CustomInput label='Enter new password' name='password' type={showPassword.password ? 'text' : 'password'} value={formValues.password} onChange={handleChange} onRightIconClick={()=>togglePasswordVisibility('password')} rightIcon={showPassword.password ?FaEye :FaEyeSlash} />
                        <CustomInput label='Confirm new password' name='cpassword' type={showPassword.cpassword ? 'text' : 'password'} value={formValues.cpassword} onChange={handleChange} onRightIconClick={()=>togglePasswordVisibility('cpassword')} rightIcon={showPassword.cpassword ?FaEye :FaEyeSlash} />
                        <CustomButton className={styles.button} loading={loading} onClick={handleResetPassword} text='Reset Password' icon={<FaArrowRight />} />
                    </Form>
                </Card>
                </div>
            </div>
        </PublicLayout>
    )
}

export default ResetPassword
